import { render, staticRenderFns } from "./my-address.vue?vue&type=template&id=4b35e648&scoped=true&"
import script from "./my-address.vue?vue&type=script&lang=js&"
export * from "./my-address.vue?vue&type=script&lang=js&"
import style0 from "./my-address.vue?vue&type=style&index=0&id=4b35e648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b35e648",
  null
  
)

component.options.__file = "my-address.vue"
export default component.exports